import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import { CaptchaModule } from 'primeng/captcha';
import { CardModule } from 'primeng/card';
import { CheckboxModule } from 'primeng/checkbox';
import { DialogModule } from 'primeng/dialog';
import { EditorModule } from 'primeng/editor';
import { InputTextModule } from 'primeng/inputtext';
import { OverlayPanelModule } from 'primeng/overlaypanel';
import { PasswordModule } from 'primeng/password';
import { RadioButtonModule } from 'primeng/radiobutton';
import { ScrollPanelModule } from 'primeng/scrollpanel';
import { AccelaTooltipDirective } from 'src/app/directives/accela-tooltip.directive';
import { SharedModule } from '../shared/shared.module';
import { DisclaimerComponent } from './components/disclaimer/disclaimer.component';
import { LoginPanelComponent } from './components/login-panel/login-panel.component';
import { RecaptchaComponent } from './components/recaptcha/recaptcha.component';
import { ContactDetailsScreenComponent } from './screens/contact-details-screen/contact-details-screen.component';
import { LoginScreenComponent } from './screens/login-screen/login-screen.component';
import { RegisterDisclaimerScreenComponent } from './screens/register-disclaimer-screen/register-disclaimer-screen.component';
import { RegisterScreenComponent } from './screens/register-screen/register-screen.component';
import { SecurityQuestionAuthScreenComponent } from './screens/security-question-auth-screen/security-question-auth-screen.component';
import { UserManagementRoutingModule } from './user-management.routes';
import { RegisterLicenseScreenComponent } from './screens/register-license-screen/register-license-screen.component';

@NgModule({
    declarations: [
        ContactDetailsScreenComponent,
        DisclaimerComponent,
        LoginPanelComponent,
        LoginScreenComponent,
        RecaptchaComponent,
        RegisterDisclaimerScreenComponent,
        RegisterScreenComponent,
        SecurityQuestionAuthScreenComponent,
        RegisterLicenseScreenComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        CardModule,
        CaptchaModule,
        CheckboxModule,
        DialogModule,
        EditorModule,
        InputTextModule,
        OverlayPanelModule,
        PasswordModule,
        RadioButtonModule,
        ScrollPanelModule,
        SharedModule,
        UserManagementRoutingModule
    ],
    exports: [
        ContactDetailsScreenComponent,
        DisclaimerComponent,
        LoginPanelComponent,
        LoginScreenComponent,
        RecaptchaComponent,
        RegisterDisclaimerScreenComponent,
        RegisterScreenComponent,
        SecurityQuestionAuthScreenComponent
    ],
    providers: [
    ]
})
export class UserManagementModule {}
